module.exports = __webpack_public_path__ + "static/media/default-card.a8ce22c0.svg";